import React from "react";
import { Box, Grid, useMediaQuery } from "@mui/material";
import { useFormContext } from "react-hook-form";
import MachineCard from "../../shared/components/MachineryCard";
import colors from "../../../shared/themes/colors";
import CustomerCard from "../../shared/components/CustomerCard";
import { useAppSelector } from "../../../shared/hooks/sharedHooks";
import { CustomerMachineState } from "../../machinery/models/models";
import { PublicState } from "../../../public/publicSlice";
import { ServiceRequest } from "../models/models";
import ViewServiceRequestGeneralInfoCard from "./ViewServiceRequestGeneralInfoCard";
import ViewServiceRequestAttachmentsCard from "./ViewServiceRequestAttachmentsCard";
import ViewServiceRequestCommercialTermsCard from "./ViewServiceRequestCommercialTermsCard";
import { dt } from "../../../shared/themes/redesignTokens";

export interface ServiceRequestPreviewProps {
  serviceRequest?: ServiceRequest;
}

const ServiceRequestPreview = ({ serviceRequest }: ServiceRequestPreviewProps) => {
  const { machine } = useAppSelector<CustomerMachineState>((state: any) => state.customerMachinery);
  const { customer } = useAppSelector<PublicState>((state: any) => state.public);
  const isPhone = useMediaQuery("(max-width:768px)");

  if (!serviceRequest || !machine) {
    return <></>;
  }

  return (
    <Box sx={{ animation: "fadeUp 0.4s cubic-bezier(0.4,0,0.2,1) both" }}>
      <Grid container direction="row" spacing={2}>
        {/* Left column -- Machine + Customer */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 1.5,
            }}
          >
            <MachineCard
              machine={machine}
              sx={{
                boxShadow: "none",
                border: `1px solid ${dt.cardBorder}`,
                borderRadius: dt.radius,
                background: dt.cardBg,
              }}
            />

            <CustomerCard customer={customer} />
          </Box>
        </Grid>

        {/* Right column -- Request details */}
        <Grid
          item
          xs={12}
          md={8}
          sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
        >
          <ViewServiceRequestGeneralInfoCard serviceRequest={serviceRequest} />
          <ViewServiceRequestCommercialTermsCard serviceRequest={serviceRequest} />
          <ViewServiceRequestAttachmentsCard serviceRequest={serviceRequest} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ServiceRequestPreview;
